import request from '@/utils/request'

// 会员积分记录列表
export const listMemberCreditLog = (pageData, formData) => {
    return request.get(`/memberCreditLog/${pageData.page}/${pageData.pageSize}`, {params:formData})
}

// 新增会员积分记录
export const addMemberCreditLog = (formData) => {
    return request.post('/memberCreditLog', formData)
}